import React, {useCallback, useState} from "react";
import "./fuelIndicator.css";
import {FuelIndicator} from "./FuelIndicator";
import {KmsIndicador} from "./kmsIndicador";

const CARDS = {
  FUEL: "fuel",
  KMS: "kms",
};

// Par de cartões (combustível + kms) usado nos passos de confirmação e de validação
// das leituras do veículo. Só um cartão pode estar em edição — e é esse que leva o
// stroke verde.
// O fuelNote é uma nota do cartão de combustível (ex.: taxa de reabastecimento) e por
// isso aparece logo a seguir a esse cartão, antes do dos kms.
export function VehicleReadings(
  {
    fuelType,
    fuelLevel,
    setFuelLevel,
    kms,
    setKms,
    fuelNote,
    t,
  }
) {
  const [editingCard, setEditingCard] = useState(null);

  const handleFuelInteractStart = useCallback(
    () => setEditingCard(CARDS.FUEL),
    [],
  );

  const handleFuelInteractEnd = useCallback(
    () => setEditingCard((current) => (current === CARDS.FUEL ? null : current)),
    [],
  );

  const handleKmsToggleEdit = useCallback(
    () => setEditingCard((current) => (current === CARDS.KMS ? null : CARDS.KMS)),
    [],
  );

  return (
    <div className="readings-stack">
      <FuelIndicator
        fuelType={fuelType}
        fuelLevel={fuelLevel}
        setFuelLevel={setFuelLevel}
        isEditing={editingCard === CARDS.FUEL}
        onInteractStart={handleFuelInteractStart}
        onInteractEnd={handleFuelInteractEnd}
      />

      {fuelNote}

      <KmsIndicador
        kms={kms}
        setKms={setKms}
        isEditing={editingCard === CARDS.KMS}
        onToggleEdit={handleKmsToggleEdit}
        t={t}
      />
    </div>
  );
}
